// removed by extract-text-webpack-plugin
module.exports = {"errorDiv":"errorDiv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account/unauthorizedIPError/style.scss
// module id = 1484
// module chunks = 0